/**
 * @file
 * Chart functionality to convert ul.chart lists into horizontal bar charts.
 */

(function ($) {
  'use strict';

  Drupal.behaviors.umsiChart = {
    attach: function (context, settings) {
      $(once('umsiChart', 'ul.chart', context)).each(function () {
        var $list = $(this);

        // Process each list item
        $list.find('li').each(function () {
          var $item = $(this);
          var text = $item.text().trim();

          // Extract percentage value (supports formats like "65%", "65", "65.5%")
          var match = text.match(/(\d+\.?\d*)\s*%?/);

          if (match) {
            var percentage = parseFloat(match[1]);
            var label = text; // Keep original text as label

            // Create bar chart HTML
            var barHtml = '<div class="chart-bar">' +
                         '<div class="chart-bar__fill" style="width: ' + percentage + '%;">' +
                         '</div>' +
                         '<div class="chart-bar__label">' + label + '</div>' +
                         '</div>';

            // Replace list item content with bar chart
            $item.html(barHtml);
          }
        });
      });
    }
  };

})(jQuery, Drupal, once);
